// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"332":"2c3b76b0","824":"8e77fa14","964":"1608339a"}[chunkId] + ".chunk.css";
};